module.exports = __webpack_public_path__ + "assets/img/masking_bg.3af6acd2.png";